const Cookie = {
  getCookie (name) {

    if (typeof document === 'undefined') {
      return null
    }

    /* eslint-disable-next-line no-useless-escape */
    const clearName = name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1')
    const regExp = new RegExp(`(?:^|; )${clearName}=([^;]*)`)
    const matches = document.cookie.match(regExp)

    return matches ? decodeURIComponent(matches[1]) : undefined
  },

  setCookie (name, value, options = {}) {
    if (typeof document === 'undefined') {
      return null
    }

    let { expires } = options

    if (typeof expires === 'number' && expires) {
      const date = new Date()
      date.setTime(
        date.getTime() + expires * 1000
      )
      expires = options.expires = date
    }

    if (expires && expires.toUTCString) {
      options.expires = expires.toUTCString()
    }

    value = encodeURIComponent(value)

    let updatedCookie = name + '=' + value

    for (const propName in options) {
      updatedCookie += '; ' + propName

      const propValue = options[propName]
      if (propValue !== true) {
        updatedCookie += '=' + propValue
      }
    }
    document.cookie = updatedCookie
  },

  deleteCookie (name, options = {}) {
    Cookie.setCookie(name, '', {
      expires: -1,
      ...options
    })
  }
}

export const getCookie = Cookie.getCookie
export const setCookie = Cookie.setCookie
export const deleteCookie = Cookie.deleteCookie

export default Cookie
